import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
// import "../blog/Blog.css";


// Import the background image
import backgroundImage from "../../assets/images/slide2.jpeg";

const Top = () => {
    const sectionStyle = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#a20000',
        backgroundBlendMode: 'multiply',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '250px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };

    return (
        <>
            <section
                className="elementor-section elementor-top-section elementor-element elementor-element-d29e141 elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default"
                data-id="d29e141"
                data-element_type="section"
                data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
                style={{ ...sectionStyle }}
            >
                <div className="elementor-background-overlay"></div>
                <Container className="elementor-container elementor-column-gap-no">
                    <Row className="elementor-row">
                        <Col className="elementor-column elementor-col-12 elementor-top-column elementor-element elementor-element-0a1c64f" data-id="0a1c64f" data-element_type="column">
                            <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                    <div
                                        className="elementor-element elementor-element-b12b60d elementor-widget elementor-widget-modina_section_title"
                                        data-id="b12b60d"
                                        data-element_type="widget"
                                        data-widget_type="modina_section_title.default"
                                    >
                                        <div className="elementor-widget-container">
                                            <div className="block-contents text-center">
                                                <div className="section-title">
                                                    <h2 >About Us</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Container className="top-summary" style={{ padding: "30px", color: "grey" }}>
                <Row>
                    <Col>
                        <p>
                            Gautam Solar, with 29+ years of experience in the solar industry is ranked among the Global Top 30 solar module manufacturers as per Wood Mackenzie. The company operates state-of-the-art solar module manufacturing facilities in Bhiwani, Haryana and Haridwar, Uttarakhand, supported by a strong pan-India and international presence.


                            <br />
                            <br />
                            Currently, Gautam Solar has 5 GW solar module manufacturing capacity, out of which 4 GW is ALMM approved and 1 GW is under process. As part of its forward integration strategy, the company is also setting up an upcoming 5 GW solar cell manufacturing facility near Gwalior, Madhya Pradesh, further strengthening its position in India’s solar manufacturing ecosystem.
                            <br />
                            <br />
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            All Gautam Solar modules are ALMM and BIS approved for the Indian market, and are manufactured in compliance with UL and IEC international standards. The company’s products are also CEC certified, making them suitable for global markets. With a strong focus on quality, reliability and advanced manufacturing, Gautam Solar continues to be a trusted partner for large-scale solar developers, EPCs and installers across India and overseas
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Top;


